/**
 * Canonical permission names as defined in the Blocks IAM permission catalog
 * (v4: `POST /iam/v4/iam/permissions` — see `useAllBlocksPermissionsQuery`). The
 * `usePermissions` hook checks the current user's role against each permission's
 * `roles[]`.
 *
 * Names that don't (yet) exist in the catalog — e.g. event/wiki — are treated
 * as allowed by `usePermissions`, so listing them here is forward-compatible:
 * the gates light up automatically once the backend adds those permissions.
 */
export const PERMISSIONS = {
  post: {
    view: "view-post",
    create: "create-post",
    update: "update-post",
    delete: "delete-post",
  },
  news: {
    view: "view-news",
    create: "create-news",
    update: "update-news",
    delete: "delete-news",
  },
  group: {
    view: "view-group",
    create: "create-group",
    update: "update-group",
    delete: "delete-group",
  },
  event: {
    view: "view-event",
    create: "create-event",
    update: "update-event",
    delete: "delete-event",
  },
  wiki: {
    view: "view-wiki",
    create: "create-wiki",
    update: "update-wiki",
    delete: "delete-wiki",
  },
} as const;

export type PermissionResource = keyof typeof PERMISSIONS;
